import $ from 'jquery';

export default function weightFilterModule() {
  const weightFilterElement = $('.weight-filter');
  if (weightFilterElement.length) {
    return import(/* webpackChunkName: "weight-filter" */ '../weightFilter')
      .then(({ default: WeightFilter }) => {
        const weightFilter = new WeightFilter();
        return weightFilter;
      })
      .catch(() => 'An error occurred while loading the component');
  }
  return null;
}
